import React from 'react';
import { AnimatedSection } from './AnimatedSection';
export function AboutSection() {
  return <section id="about" className="py-16 bg-gray-50" data-id="element-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-17">
        <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center" data-id="element-18">
          <AnimatedSection data-id="element-19">
            <div className="relative mb-12 lg:mb-0" data-id="element-20">
              <div className="aspect-w-3 aspect-h-2 rounded-lg overflow-hidden shadow-xl" data-id="element-21">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/k4ZeWaA9P4YhpMporEVnt6/1747069927637.jpg" alt="Team meeting in a modern office space with city views" className="w-full h-full object-center object-cover" data-id="element-22" />
              </div>
              <div className="absolute -bottom-6 -right-6 w-64 h-64 bg-indigo-100 rounded-lg -z-10" data-id="element-23"></div>
            </div>
          </AnimatedSection>
          <AnimatedSection delay={0.2} data-id="element-24">
            <div data-id="element-25">
              <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl mb-6" data-id="element-26">
                About Turnout
              </h2>
              <p className="text-lg text-gray-700 mb-6" data-id="element-27">
                Turnout delivers concierge-level event planning with a focus on
                excellence and efficiency. We combine experienced professionals
                with smart technology to ensure every event runs smoothly and
                meets your goals.
              </p>
              <p className="text-lg text-gray-700 mb-6" data-id="element-28">
                From corporate conferences to social celebrations, we handle the
                details so you can focus on what matters most. Our approach is
                rooted in clear communication, reliability, and a commitment to
                creating events that impress - without overextending your
                budget.
              </p>
              <div className="grid grid-cols-2 gap-4 text-center" data-id="element-29">
                <AnimatedSection delay={0.4} data-id="element-30">
                  <div className="bg-white p-4 rounded-lg shadow-sm" data-id="element-31">
                    <p className="text-3xl font-bold text-indigo-600" data-id="element-32">100%</p>
                    <p className="text-gray-600" data-id="element-33">Client Satisfaction</p>
                  </div>
                </AnimatedSection>
                <AnimatedSection delay={0.5} data-id="element-34">
                  <div className="bg-white p-4 rounded-lg shadow-sm" data-id="element-35">
                    <p className="text-3xl font-bold text-indigo-600" data-id="element-36">$1M+</p>
                    <p className="text-gray-600" data-id="element-37">Event Budgets</p>
                  </div>
                </AnimatedSection>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>;
}